import { waitForObserver } from '~/helpers/helpers'

waitForObserver(['.swym-modals-container'], () => {
  const shareBtn = document.querySelector('.swym-share-wishlist-email-btn')
  const shareBtnContainer = document.querySelector('.swym-share-email-button-container')
  const closeBtn = document.querySelector('.swym-close-btn')

  shareBtn && shareBtn.addEventListener('click', () => {
    if (!shareBtnContainer.querySelector('.share-confirmation-message')) {
      const confirmationMessage = document.createElement('span')
      confirmationMessage.setAttribute('class', 'share-confirmation-message')
      confirmationMessage.innerText = 'Message has been sent successfully'

      shareBtnContainer.prepend(confirmationMessage)
      shareBtn.remove()

      setTimeout(() => {
        closeBtn.click()
      }, 5000)
    }
  })
})


